import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import SectoralIndicesFull from './sectoral-indices-full';

const SectoralIndicesFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <SectoralIndicesFull {...props} />
    </QueryClientProvider>
  );
};

export { SectoralIndicesFullWidget }
